<template>
  <div class="statistics" v-loading="loading || rankingLoading">
    <!-- <ProgressCircle :percentage="completedProblemsPercentage" :scale="3" />
    <h1>{{Math.ceil(totalScore)}}</h1>-->
    <div style="min-height: 375px" v-if="tabIndex === 1">
      <div class="ranking-container" v-if="tabIndex === 1">
        <TestResult @load-finished="onLoadFinished" @load-start="onLoadStart" />
      </div>
    </div>

    <div class="result-list" v-if="tabIndex === 2">
      <div class="no-data" v-show="tabIndex === 2 && results.length === 0">まだテストの受験記録がありません</div>
      <div class="table-row">
        <div class="result-item-header">受験日時</div>
        <div class="result-item-header" style="flex: 0.3">スコア</div>
        <div class="result-item-header">間違いが多かった発音記号</div>
      </div>
      <div class="body">
        <div class="table-row" v-for="(result, index) in results" :key="index">
          <div class="result-item-content">{{ fbDateToString(result.date.seconds * 1000) }}</div>
          <div
            class="result-item-content"
            style="flex: 0.3; font-weight:bold"
          >{{ result.totalScore }}</div>
          <div class="result-item-content">
            <div class="phonemes">
              <div class="phoneme" v-for="phoneme in listError(result.chartData)">{{ phoneme }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="ranking-container" v-if="tabIndex === 0">
      <Ranking
        @to-ranking-tab="onRankingClicked()"
        @load-finished="onLoadFinished"
        @load-start="onLoadStart"
      />
    </div>
    <div class="tab">
      <div class="tab-item" :class="{ active: tabIndex === 0 }" @click="setRanking">統計情報</div>
      <div class="tab-item" :class="{ active: tabIndex === 1 }" @click="tabIndex = 1">ランキング</div>
      <div class="tab-item" :class="{ active: tabIndex === 2 }" @click="tabIndex = 2">テスト受験履歴</div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
Vue.use(require("vue-chartist"));
import { db } from "@/plugins/firebase";
import { fbDateToString } from "@/utils/functions";

export default {
  components: {
    Ranking: require("./Ranking").default,
    TestResult: require("./TestResult").default
  },
  methods: {
    onRankingClicked() {
      this.tabIndex = 1;
    },
    onLoadStart() {
      this.rankingLoading = true;
    },
    onLoadFinished() {
      this.rankingLoading = false;
    },
    setRanking() {
      this.tabIndex = 0;
    },
    listError(list) {
      return list
        .map(ph => ph.phoneme)
        .join(" ")
        .replace(" other", "")
        .split(" ");
    },
    fbDateToString
  },
  data() {
    return {
      rankingLoading: false,
      myRanking: null,
      othersRanking: null,
      totalRanking: null,
      loading: true,
      tabIndex: 0,
      noChartData: true,
      results: [],
      chartData: {
        series: [[4213, 5355, 7543, 7200, 9024, 12400]],
        labels: [["1", "2", "3", "4", "5", "6"]]
      },

      chartOptions: {
        axisX: {
          labelInterpolationFnc: function(value, index, label) {
            if (label.length > 20 && label.length <= 40) {
              return index % 2 === 0 ? value : null;
            } else if (label.length > 40) {
              return index % 10 === 0 ? value : null;
            } else {
              return String(parseInt(value) + 1) + "回目";
            }
          }
        },
        lineSmooth: this.$chartist.Interpolation.simple({
          divisor: 2,
          fillHoles: false
        }),
        height: "350px"
      }
    };
  },
  async mounted() {
    let results = [];
    try {
      const resultRef = await db
        .collection("users")
        .doc(this.$store.state.auth.user.uid)
        .collection("TestResults")
        .orderBy("date", "desc")
        .get();
      resultRef.forEach(doc => {
        results.push(doc.data());
      });
      this.results = results;
      if (results.length > 0) {
        this.noChartData = false;
        const chartData = results.map(result => result.totalScore);

        this.chartData = {
          series: [chartData],
          labels: chartData.map((s, index) => {
            return index.toString();
          })
        };
      }
    } finally {
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.statistics {
  height: 100%;
  /* width: 100%; */
  min-height: 420px;
  margin: 0 50px;
  overflow: auto;
  box-sizing: border-box;
  border: 1px solid rgba(0, 0, 0, 0.1);

  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @include mq(sm) {
    /* width: 100%; */
  }
  @include mq(md) {
    /* width: 100%; */
  }
  @include mq(lg) {
    /* width: 100%; */
  }
  @include mq(xl) {
    /* width: 100%; */
  }

  .tab {
    display: flex;
    flex-direction: row;
    border-top: 1px solid rgba(0, 0, 0, 0.05);
    width: 100%;
    justify-content: space-evenly;
    position: relative;
    .tab-item {
      display: inline-block;
      padding: 10px 0;
      width: 100%;
      height: 100%;
      font-weight: bold;
      font-size: 0.9rem;
      cursor: pointer;
      text-align: center;
      &:hover {
        background-color: #eee;
        color: #333;
      }
    }

    .active {
      background-color: #555 !important;
      color: #fff !important;
    }
  }
  .no-data {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 10px 40px;
    width: 256px;
    height: 24px;
    user-select: none;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
    border-radius: 5px;
    background-color: white;
    box-shadow: 0 0 13px 0 rgba(0, 0, 0, 0.1);
    border-radius: 30px;
    z-index: 30;
    font-weight: bold;
  }
  .legend {
    bottom: -35px;
    left: 50%;
    font-weight: 600;
    z-index: 50;
    font-size: 1rem;
  }
  .chart {
    height: 360px !important;
    margin: auto;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    padding: 10px;
    box-sizing: border-box;
  }
}

.result-list {
  display: flex;
  flex-direction: column;
  .table-row {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    padding: 3px 0;
    min-height: 34px;
  }
  .body {
    overflow-y: scroll;
  }
  .result-item-header {
    text-align: center;
    flex: 1;
    font-size: 0.9rem;
    font-weight: bold;
    padding-top: 10px;
    padding-bottom: 5px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  }
  .result-item-content {
    text-align: center;
    flex: 1;
  }
}

.phonemes {
  display: flex;
  flex-direction: row;
  justify-content: center;
  .phoneme {
    display: inline-block;
    padding: 5px;
    font-weight: bold;
    cursor: pointer;
    &:hover {
      color: #f88;
    }
  }
}

.ranking-container {
  height: 375px;
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>
